import { AddressBookMapper } from '../AddressBookMapper.js';
import { WarehouseAddressesMapper } from './WarehouseAddressesMapper.js';

class WarehouseAddressesRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get() {
    return this.apiClient.get('v1/warehouses').then(response => WarehouseAddressesMapper.createWarehouseAddressFromResponse(response.data));
  }
  create(warehouse) {
    return this.apiClient.post('v1/clients/warehouses', AddressBookMapper.createApiPayload(warehouse)).then(response => {
      return {
        ...warehouse,
        id: response.data.id
      };
    });
  }
  update(warehouse) {
    return this.apiClient.put(`v1/clients/warehouses/${warehouse.id}`, AddressBookMapper.createApiPayload(warehouse)).then(() => warehouse);
  }
  setDefault(id) {
    return this.apiClient.put(`v1/clients/warehouses/${id}/default`).then(response => response.data);
  }
  delete(id) {
    return this.apiClient.delete(`v1/clients/warehouses/${id}`).then(response => response.data);
  }
}

export { WarehouseAddressesRepository };
//# sourceMappingURL=WarehouseAddressesRepository.js.map
